module.exports = __webpack_public_path__ + "media/recipes/62-1d0f24be.png";